<template>
  <div class="item-shadow" v-if="shown" :style="style">
    <div v-if="config.texture_url" class="item-shadow-texture"><div class="item-shadow-texture-img" :style="{ backgroundImage: `url(${config.texture_url})` }"></div></div>
    <div v-else class="item-shadow-image"><img :src="config.svg_url"></div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      tracking: false,
      top: 0,
      left: 0,
    }
  },
  computed: {
    ...mapState({
      config: state => state.item.shadow_config,
      visible: state => state.item.shadow,
    }),
    shown() {
      return this.config && this.visible && this.moving
    },
    style() {
      return {
        top: `${this.top}px`,
        left: `${this.left}px`,
      }
    },
    moving() {
      return this.top > 0 && this.left > 0
    },
  },
  watch: {
    config(config) {
      if (config) {
        this.trackingStart()
      } else {
        this.trackingFinish()
      }
    },
  },
  methods: {
    trackingStart() {
      this.top = 0
      this.left = 0
      if (this.tracking == false) {
        window.addEventListener('pointermove', this.pointermove)
        window.addEventListener('touchmove', this.touchmove, { passive: false })
      }
      this.tracking = true
    },
    trackingFinish() {
      if (this.tracking == true) {
        window.removeEventListener('pointermove', this.pointermove)
        window.removeEventListener('touchmove', this.touchmove, { passive: false })
      }
      this.tracking = false
    },
    pointermove(event) {
      this.top = event.pageY
      this.left = event.pageX
    },
    touchmove(event) {
      event.preventDefault()
      this.top = event.touches[0].pageY
      this.left = event.touches[0].pageX
    },
  },
}
</script>

<style lang="scss" scoped>
.item-shadow {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -40px;
  margin-left: -40px;
  width: 80px;
  height: 80px;
  pointer-events: none;
  z-index: 10;
}
.item-shadow-texture {
  width: 100%;
  height: 100%;
  border: 1px solid #888;
  background-color: #66ff66;
  opacity: .75;
  .item-shadow-texture-img {
    width: 100%;
    height: 100%;
    background-size: 20px 20px;
    opacity: .25;
  }
}
.item-shadow-image {
  background-color: #66ff66;
  opacity: .75;
  img {
    opacity: .25;
  }
}
</style>



// WEBPACK FOOTER //
// assets/js/components/ItemShadow.vue